<svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
  <path d="M2 14.5H15" stroke="#E5E5E5" stroke-width="1.4" stroke-linecap="round"/>
  <path d="M4 14.5V2.5H8.5V14.5" stroke="#E5E5E5" stroke-width="1.3" stroke-linecap="round"/>
  <path d="M8.5 2.5H13.5V5.5" stroke="#E5E5E5" stroke-width="1.3" stroke-linecap="round"/>
  <path d="M10.5 5.5H16.5" stroke="#E5E5E5" stroke-width="1.6" stroke-linecap="round"/>
  <path d="M11 14.5V10.5H14.5V14.5" stroke="#E5E5E5" stroke-width="1.3" stroke-linecap="round"/>
  <rect x="4.8" y="4.5" width="2.4" height="7.5" rx="0.4" fill="#E5E5E5"/>
</svg>
